import angular from 'angular'
import kickerAdminComponent from './kickerAdmin.component'

export default angular
  .module('ellipsis.kickerAdmin', [])
  .component('kickerAdmin', kickerAdminComponent)
